import { Database } from "lucide-react";

import { useGrantSqlAccess } from "@/hooks/infrastructure/useGrantSqlAccess";
import useUserStore from "@/stores/useUserStore";
import { canUseSqlAccess } from "@/utils/sql-access";

import classes from "./fast-access.module.scss";

function SqlAccessButton() {
	const user = useUserStore((state) => state.user);
	const { mutate: grantAccess, isLoading } = useGrantSqlAccess();

	if (!canUseSqlAccess(user)) {
		return null;
	}

	const handleGrantAccess = () => {
		if (isLoading) {
			return;
		}

		grantAccess();
	};

	return (
		<div className={classes.div_access}>
			<div
				className={classes.access_card}
				onClick={handleGrantAccess}
				title="Agregar mi IP actual al security group para acceder a SQL"
				role="button"
				tabIndex={0}
				onKeyDown={(event) => {
					if (event.key === "Enter" || event.key === " ") {
						event.preventDefault();
						handleGrantAccess();
					}
				}}
				style={isLoading ? { opacity: 0.7, pointerEvents: "none" } : undefined}
			>
				<Database size={18} style={{ marginRight: "6px" }} />
				<span className={classes.access_card_span}>{isLoading ? "Actualizando…" : "Acceso SQL"}</span>
			</div>
		</div>
	);
}

export default SqlAccessButton;
